export class ShipToSenderDTO {
  labId: string;
  sample: string;
  batchID: string;
  destination: string;
  shippedUserPUID: string;
  shippedTimestamp: Date;
}

export class ResultViewDTO {
  channelTestingTypeMapping : any[];
  samples : SampleResultViewDTO;
}
export class SampleResultViewDTO {
  positionRow : number;
  prositionCol : number;
  channels : any[];
  results : any[];
  result : string
}
